<template>
  <!-- this type of banner is vertical on mobile resolution and horizontal on desktop -->
  <v-card
    :href="link"
    @click.prevent="handleLink"
    :style="cardStyle"
    class="proposal-card-overlay"
    v-intersect.once="handleView"
    :id="`proposal-card-overlay-${proposal.id}`"
    :class="
      $ebsn.meta(proposal, 'metaData.category_proposal_type.TEXT_POSITION')
    "
  >
    <v-img
      eager
      :src="imgSrc"
      :alt="proposal.imgAlt"
      :title="proposal.imgDescription"
      :id="`proposal-image-${proposal.id}`"
    >
      <div
        v-if="!$ebsn.meta(proposal, 'category_proposal_type.HIDE_BLACK_LAYER')"
        class="blurred-bg"
      ></div>
      <div class="text-overlay">
        <img
          v-if="$ebsn.meta(proposal, 'metaData.category_proposal_type.ICON')"
          :src="$ebsn.meta(proposal, 'metaData.category_proposal_type.ICON')"
          alt="icon"
          class="icon"
        />
        <v-card-title
          v-if="proposal.descr"
          v-html="proposal.descr"
        ></v-card-title>
        <v-card-text
          v-if="proposal.content"
          v-html="proposal.content"
        ></v-card-text>
        <v-card-actions
          v-if="
            $ebsn.meta(proposal, 'metaData.category_proposal_type.TEXT_BTN')
          "
        >
          <v-btn
            :href="link"
            outlined
            :color="
              $ebsn.meta(
                proposal,
                'metaData.category_proposal_type.COLOR_BTN',
                'white'
              )
            "
            >{{
              $ebsn.meta(proposal, "metaData.category_proposal_type.TEXT_BTN")
            }}</v-btn
          >
        </v-card-actions>
      </div>
    </v-img>
  </v-card>
</template>
<style lang="scss">
.proposal-card-overlay.v-card {
  overflow: hidden;
  height: 100%;
  .blurred-bg:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, transparent 30%, black 100%);
  }
  .v-image {
    height: 100%;
    color: inherit;
  }
  &.bottom {
    .text-overlay {
      bottom: 0px;
      position: absolute;
      width: 100%;
    }
    &.bottom-left {
      .v-card__title {
        text-align: left;
        justify-content: start;
      }
    }
  }
  p {
    padding: 0px;
    margin: 0px;
  }
}
</style>
<script>
import banner from "~/mixins/banner";

import get from "lodash/get";

export default {
  name: "ProposalCardOverlay",
  props: {
    proposal: { type: Object, required: true }
  },
  mixins: [banner],
  computed: {
    cardStyle() {
      let style = {};
      let backgroundColor = get(
        this.proposal,
        `metaData.category_proposal_type.BACKGROUND_COLOR`
      );
      if (backgroundColor) {
        style.backgroundColor = backgroundColor;
      }
      let textColor = get(
        this.proposal,
        `metaData.category_proposal_type.TEXT_COLOR`
      );
      if (textColor) {
        style.color = textColor;
      }

      return style;
    },
    imgSrc() {
      let prop =
        "metaData.category_proposal_type." +
        (!this.$vuetify.breakpoint.xsOnly ? "IMAGE_DESKTOP" : "IMAGE_MOBILE");
      return get(this.proposal, prop, this.proposal.img);
    }
  }
};
</script>
